<template>
  <v-dialog
    transition="dialog-bottom-transition"
    persistent
    v-model="dialog"
    max-width="300"
  >
    <v-date-picker
      v-model="selectedDates"
      first-day-of-week="1"
      locale="es-mx"
      range
    >
      <v-spacer></v-spacer>
      <v-btn small text @click="close"> Cancelar </v-btn>
      <v-btn small outlined color="success" @click="saveDateRange">
        Aceptar
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import dataTableMixin from "../mixins/mixin-data-tables";
import { compareAndSortDates } from "../services/utils";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "NavDatePickerModal",
  mixins: [dataTableMixin],
  props: {
    context: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["isNavDatePickerModalOpen", "datePickerModalContext"]),
    dialog: {
      get: function () {
        const isContextMatch = this.context === this.datePickerModalContext;
        return this.isNavDatePickerModalOpen && isContextMatch;
      },
      set: function (shouldShow) {
        this.showNavDatePickerModal(shouldShow);
      },
    },
  },
  methods: {
    ...mapActions(["showNavDatePickerModal", "changeDatePickerModalContext"]),
    close() {
      this.dialog = false;
      this.changeDatePickerModalContext("GLOBAL");
    },
    saveDateRange() {
      const dates = this.isPendientesContext
        ? [...this.singleDate]
        : [...this.dates];
      const sortedDates = compareAndSortDates(dates);
      this.$emit("dateRangeSelected", sortedDates);
      this.close();
    },
  },
};
</script>